<div class="page-shell page-shell--canvas">
  <div class="dc-wrapper">
    <div class="dc-layout">
      <div class="dc-section dc-sidebar">
        <div class="dc-section__header">
          <h2 class="dc-section__title">{{ "meetBackground.title" | translate }}</h2>
        </div>
        <div class="dc-section__content">
          @if (selected) {
            <div
              class="dc-employee-picker-wrap"
              [hidden]="!employeePickerReady"
            >
              <app-digital-card-employee-picker
                [value]="previewEmployee"
                [templateContextId]="pickerTemplateContextId"
                (valueChange)="onPreviewEmployeeChange($event)"
                (initialSelectionResolved)="onEmployeePickerInitialResolved()"
              ></app-digital-card-employee-picker>
            </div>
          }
          @if (!listBusy) {
            <button type="button" class="dc-add-card" (click)="createNew()">
              <mat-icon>add</mat-icon>
              <span>{{ "meetBackground.create" | translate }}</span>
            </button>
          }
          <div class="dc-list">
            @if (!listBusy) {
              @for (item of items; track item.meetBackgroundId) {
                <button
                  type="button"
                  class="dc-list-item"
                  [class.dc-list-item--selected]="isSelected(item)"
                  (click)="select(item)"
                >
                  <div class="dc-list-meta">
                    <div class="dc-list-name-row">
                      <span class="dc-list-name">{{ item.name }}</span>
                      @if (item.isDefault) {
                        <span class="dc-list-default">
                          <mat-icon>check</mat-icon>
                          {{
                            "digitalCards.default.unsetDefaultButton" | translate
                          }}
                        </span>
                      }
                    </div>
                  </div>
                </button>
              }
            }
          </div>
          @if (listBusy) {
            <div class="dc-list-syncing dc-list-syncing--sidebar" aria-busy="true">
              <mat-spinner diameter="28"></mat-spinner>
            </div>
          }
        </div>
      </div>

      <div class="dc-section dc-main">
        @switch (mainPhase) {
          @case ("boot") {
            <div class="dc-section__content dc-empty-wrap">
              <div class="dc-empty-state dc-empty-state--syncing">
                <mat-spinner diameter="36"></mat-spinner>
                <p>{{ "meetBackground.syncing" | translate }}</p>
              </div>
            </div>
          }
          @case ("empty") {
            <div class="dc-section__content dc-empty-wrap">
              <div class="dc-empty-state">
                <mat-icon>videocam</mat-icon>
                <button mat-raised-button color="primary" (click)="createNew()">
                  <mat-icon>add</mat-icon>
                  {{ "meetBackground.addFirst" | translate }}
                </button>
              </div>
            </div>
          }
          @default {
            @if (mainReady) {
              <div class="dc-section__header dc-main-header">
                <div class="dc-title-row">
                  <h2 class="dc-section__title">{{ selected!.name }}</h2>
                  @if (selected!.isDefault) {
                    <button
                      type="button"
                      class="dc-title-default-button dc-title-default-button--active"
                      disabled
                      [attr.aria-label]="
                        'digitalCards.default.unsetDefaultButton' | translate
                      "
                    >
                      <mat-icon>check</mat-icon>
                      {{ "digitalCards.default.unsetDefaultButton" | translate }}
                    </button>
                  } @else {
                    <button
                      type="button"
                      class="dc-title-default-button"
                      [disabled]="
                        defaultSettingTemplateId === selected!.meetBackgroundId
                      "
                      (click)="setAsDefault(selected!)"
                      [attr.aria-label]="
                        'digitalCards.default.setDefaultButton' | translate
                      "
                    >
                      @if (
                        defaultSettingTemplateId === selected!.meetBackgroundId
                      ) {
                        <mat-spinner
                          diameter="14"
                          class="dbc1-spinner dbc1-spinner--sm"
                        ></mat-spinner>
                      } @else {
                        <mat-icon>star_outline</mat-icon>
                      }
                      {{ "digitalCards.default.setDefaultButton" | translate }}
                    </button>
                  }
                </div>
                <div class="dc-actions">
                  <button type="button" (click)="editSelected()" class="action-btn">
                    <mat-icon>edit</mat-icon>
                    {{ "edit" | translate }}
                  </button>
                  <button
                    type="button"
                    (click)="remove()"
                    [disabled]="deleting"
                    class="action-btn action-btn--danger dc-action-delete"
                  >
                    @if (deleting) {
                      <mat-spinner
                        diameter="18"
                        class="dbc1-spinner dbc1-spinner--sm"
                      ></mat-spinner>
                    } @else {
                      <mat-icon>delete_outline</mat-icon>
                    }
                    {{
                      deleting
                        ? ("digitalCards.deleting" | translate)
                        : ("delete" | translate)
                    }}
                  </button>
                </div>
              </div>
            }
            <div class="dc-section__content dc-preview-content">
              @if (!mainReady) {
                <div class="dc-preview-content-center">
                  <div class="dc-empty-state dc-empty-state--syncing">
                    <mat-spinner diameter="36"></mat-spinner>
                    <p>{{ "meetBackground.syncing" | translate }}</p>
                  </div>
                </div>
              } @else if (previewBindings; as preview) {
                <app-meet-background-preview
                  [layoutVariant]="preview.layoutVariant"
                  [barWidth]="preview.barWidth"
                  [corner]="preview.corner"
                  [logoCorner]="preview.logoCorner"
                  [showQrCaption]="preview.showQrCaption"
                  [qrCaption]="preview.qrCaption"
                  [showEmployeeName]="preview.showEmployeeName"
                  [previewEmployeeName]="preview.previewEmployeeName"
                  [showJobTitle]="preview.showJobTitle"
                  [previewJobTitle]="preview.previewJobTitle"
                  [showLogo]="preview.showLogo"
                  [logoUrl]="preview.logoUrl"
                  [qrData]="preview.qrData"
                  [opacity]="preview.opacity"
                  [qrBackgroundColor]="preview.qrBackgroundColor"
                  [logoOpacity]="preview.logoOpacity"
                  [logoBackgroundColor]="preview.logoBackgroundColor"
                  [marginPx]="preview.marginPx"
                  [logoMarginPx]="preview.logoMarginPx"
                  [sizeRatio]="preview.sizeRatio"
                  [logoSizeRatio]="preview.logoSizeRatio"
                  [fontFamily]="preview.fontFamily"
                  [fontCssUrl]="preview.fontCssUrl"
                  [companyFontFileUrl]="preview.companyFontFileUrl"
                  [loading]="false"
                  [renderedImageUrl]="preview.renderedImageUrl"
                ></app-meet-background-preview>
              }
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
